import {
  ForgotPasswordForm,
  ForgotPasswordFormData,
} from '@features/user/auth';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { requestResetPasswordAdmin } from '@src/services/adminAuth.ts';
import { useNavigate } from 'react-router-dom';
import { USER_NOT_FOUND } from '@src/constants';

export const AdminForgotPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleForgotPassword = async (data: ForgotPasswordFormData) => {
    try {
      await requestResetPasswordAdmin(data.email);
      navigate('/admin/forgot-password-otp', {
        state: {
          email: data.email,
        },
      });
    } catch (err: any) {
      if (err.response && err.response.data.message.includes(USER_NOT_FOUND)) {
        toast.error(err.response.data.message);

        return;
      }
      toast.error(t('toast.failedToSendEmail'));
    }
  };

  return (
    <ForgotPasswordForm
      className={'bg-[#242C36]'}
      description={
        "Please enter your email address. We'll send a verification code (OTP) to your email address."
      }
      labelButton={'Send OTP'}
      onSubmit={handleForgotPassword}
    />
  );
};
